import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../common/integrations'
import { IntegrationIcon } from '../../../../../../components/IntegrationIcon'
import { ReactComponent as ZocksIcon } from '../../../../../../assets/ZocksIcon.svg'
import { ContactLinkingRows } from './ContactLinkingRows'
import { ContactLinkingSection } from './ContactLinkingSection'
import { Path, useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../schema'
import { useGetSchemaErrors } from '../../schemaErrors'
import { HouseholdCheckbox } from '../InboundMappingSettings/shared/HouseholdCheckbox'

export interface ContactLinkingProps {
  serviceId: IntegrationServiceId
  zocksObjectName: string
  mappingPath: string
  isDisabled?: boolean
  onChange?: () => void
  showHouseholdCheckbox?: boolean
  allowClearing?: boolean
}

export const ContactLinking: React.FC<ContactLinkingProps> = ({
  serviceId,
  zocksObjectName,
  mappingPath,
  isDisabled = false,
  onChange,
  showHouseholdCheckbox = true,
  allowClearing = false,
}) => {
  const { watch } = useFormContext<IntegrationSettings>()
  const { getErrorOnPath } = useGetSchemaErrors()

  const contactObject = watch(`mappings.contact.objectName` as const)

  const contactLinksPath = `${mappingPath}.contactLinks` as Path<IntegrationSettings>

  const linkingError = getErrorOnPath(contactLinksPath)

  return (
    <ContactLinkingSection
      description={
        <>
          Link {zocksObjectName} to {getIntegrationDisplayName(serviceId)} {contactObject}.
        </>
      }
      sourceHeading={{ icon: <ZocksIcon width='1rem' height='1rem' />, label: 'ZOCKS FIELD' }}
      targetHeading={{
        icon: <IntegrationIcon serviceId={serviceId} width='1rem' height='1rem' fill='black' />,
        label: getIntegrationDisplayName(serviceId).toUpperCase(),
      }}
      error={linkingError}
      footer={showHouseholdCheckbox ? <HouseholdCheckbox mappingPath={mappingPath} isDisabled={isDisabled} onChange={onChange} /> : null}
    >
      <ContactLinkingRows serviceId={serviceId} mappingPath={mappingPath} isDisabled={isDisabled} onChange={onChange} allowClearing={allowClearing} />
    </ContactLinkingSection>
  )
}
